// @flow
import type { IdealistDayEvent as ApiIdealistDayEvent } from 'api/groupAdmin';
import type { Action } from '../../actions/groupDashboard/idealistDayEvents';

export type IdealistDayEvent = {
  ...$Exact<ApiIdealistDayEvent>,
  isFetching: boolean
};

export type State = {
  byId: {
    [string]: IdealistDayEvent
  },
  byGroupId: {
    [string]: {
      idealistDayEventIds: Array<string>,
      isFetching: boolean
    }
  }
};

export default function events(
  state: State = { byId: {}, byGroupId: {} },
  action: Action
) {
  switch (action.type) {
    case 'GROUP_DASHBOARD_FETCH_IDEALIST_DAY_EVENT_REQUEST':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.eventId]: {
            ...state.byId[action.eventId],
            id: action.eventId,
            isFetching: true
          }
        }
      };
    case 'GROUP_DASHBOARD_FETCH_IDEALIST_DAY_EVENT_SUCCESS': {
      const { event, groupId } = action;

      const newState = {
        ...state,
        byId: {
          ...state.byId,
          [event.id]: {
            ...action.event,
            isFetching: false
          }
        }
      };

      const groupEvents = state.byGroupId[groupId];
      if (groupEvents && !groupEvents.isFetching) {
        const idealistDayEventIds = groupEvents.idealistDayEventIds;
        if (!idealistDayEventIds.includes(event.id)) {
          newState.byGroupId[groupId].idealistDayEventIds = [
            ...idealistDayEventIds,
            event.id
          ];
        }
      }

      return newState;
    }
    case 'GROUP_DASHBOARD_FETCH_IDEALIST_DAY_EVENTS_REQUEST':
      return {
        ...state,
        byGroupId: {
          ...state.byGroupId,
          [action.groupId]: {
            ...state.byGroupId[action.groupId],
            isFetching: true
          }
        }
      };
    case 'GROUP_DASHBOARD_FETCH_IDEALIST_DAY_EVENTS_SUCCESS': {
      const newState = { ...state };
      action.events.forEach(event => {
        newState.byId[event.id] = { ...event, isFetching: false };
      });
      newState.byGroupId[action.groupId] = {
        idealistDayEventIds: action.events.map(e => e.id),
        isFetching: false
      };
      return newState;
    }
    case 'GROUP_DASHBOARD_REMOVE_GROUP_IDEALIST_DAY_EVENT': {
      const { eventId, groupId } = action;
      const eventIds = state.byGroupId[groupId].idealistDayEventIds || [];
      return {
        ...state,
        byGroupId: {
          ...state.byGroupId,
          [action.groupId]: {
            idealistDayEventIds: eventIds.filter(id => id !== eventId)
          }
        }
      };
    }
    default:
      // this causes a flow error if there are any unhandled actions
      (action: empty); // eslint-disable-line no-unused-expressions
      return state;
  }
}
